import { ScaleLib } from '@tunasong/music-lib'
import type { NoteName, Scale } from '@tunasong/schemas'

const KEY_ROW = ['q', 'w', 'e', 'r', 't', 'y', 'u'] as const

/**
 * Map a single keyboard key to the in-scale pitch at the corresponding
 * scale degree. The Z-shaped accelerator: `q-w-e-r-t-y-u` walk the seven
 * scale degrees in order. Mode-aware via `ScaleLib.getNotes(scale)` — in
 * D Dorian, `y` (the 6th scale degree) returns B (the ♮6), not Bb.
 *
 * Returns `null` for any unmapped key. Caller decides whether to swallow
 * the keystroke or pass it through.
 */
export const mapKeyToPitch = (key: string, scale: Scale): NoteName | null => {
  const idx = KEY_ROW.indexOf(key as (typeof KEY_ROW)[number])
  if (idx < 0) {
    return null
  }
  const scaleNotes = ScaleLib.getNotes(scale)
  return scaleNotes[idx] ?? null
}
